import React, { FunctionComponent } from 'react';
import type { FallbackProps } from 'react-error-boundary';
import { StyledErrorBoundaryFallback } from './ErrorBoundaryFallback.styles';

export const ErrorBoundaryFallback: FunctionComponent<FallbackProps> = () => {
  return <StyledErrorBoundaryFallback>Something went wrong.</StyledErrorBoundaryFallback>;
};
